import { render, staticRenderFns } from "./TaskReviewTranscriptView.vue?vue&type=template&id=3753380b&scoped=true&"
import script from "./TaskReviewTranscriptView.vue?vue&type=script&lang=ts&"
export * from "./TaskReviewTranscriptView.vue?vue&type=script&lang=ts&"
import style0 from "./TaskReviewTranscriptView.vue?vue&type=style&index=0&id=3753380b&prod&lang=css&"
import style1 from "./TaskReviewTranscriptView.vue?vue&type=style&index=1&id=3753380b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753380b",
  null
  
)

export default component.exports